
<template>
  <div>
    <IKFiltroCliente ref="ikFiltroCliente"/>     
    <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3" @click="exportarPdf"/>
    <Button icon="pi pi-file" class="p-ml-2" title="Exporta para arquivo XLS" @click="exportarXls"/>
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroCliente from '@/components/template/IKFiltroCliente';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, download } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {
            let dados = this.$refs.ikFiltroCliente.getClientes();            
            if(dados.clientes.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais clientes', true);
                return;
            }
            let idsClientes = [];
            dados.clientes.forEach(client => {
                idsClientes.push(client.id);
            });
            let requisicao = { 
                status: dados.status,
                idsClientes: idsClientes,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.clienteIK(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        exportarXls() {
            let dados = this.$refs.ikFiltroCliente.getClientes();            
            if(dados.clientes.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais clientes', true);
                return;
            }
            let idsClientes = [];
            dados.clientes.forEach(client => {
                idsClientes.push(client.id);
            });
            let requisicao = { 
                status: dados.status,
                idsClientes: idsClientes,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.clienteIKXls(requisicao)
            .then(resp => {                   
                download(resp.data, resp.headers['ik-response']); 
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });           
        }
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    components: {
        'IKFiltroCliente': IKFiltroCliente,
    }
}
</script>

<style>

</style>